import Breadcrumb from '@carvana/ds-breadcrumb';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';

type OwnProps = {
  make: string;
  parentModel?: string;
};

export default function BreadcrumbBar({ make, parentModel }: OwnProps) {
  const crumbs = parentModel
    ? [
        { href: `/new/${toLowerKebabCase(make)}`, label: make },
        { label: parentModel }
      ]
    : [{ href: '/new', label: 'All Brands' }, { label: make }];

  return (
    <div className="flex items-center justify-between">
      <Breadcrumb backIcon={false} crumbs={crumbs} size="sm" />
    </div>
  );
}
